import React from 'react'
import { useParams } from 'react-router-dom'
import { CobrowseViewer } from './CobrowseViewer'

/**
 * Full-window co-browse mirror, opened when the agent presses "Pop out" in the
 * in-chat viewer. Chrome-free (no dashboard Layout) so the visitor's screen
 * gets the whole window. Auth + socket come from the app-level providers.
 */
export const CobrowseStandalonePage: React.FC = () => {
  const { chatId } = useParams<{ chatId: string }>()
  if (!chatId) return null
  return (
    <div className="h-screen w-screen bg-surface">
      <CobrowseViewer chatId={chatId} standalone />
    </div>
  )
}
